import React from "react";
import { Outlet } from "react-router-dom";

const CountryRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default CountryRoot;
